import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ZendeskChatContext } from '@qover/contexts';
// @ts-ignore
import { GlobalLayoutStyles } from '@qover/styles';
import Config from '@qover/utils/src/Config';
import { LegalMentions, Chat, ChatWrapper, showChat } from '@qover/molecules';
import { TopBar, Footer, Faq } from '@qover/organisms';

import { InnerContainer } from './teslaLayout.styles';
import { Path } from '../../domain/Step';
import { Draft } from '../../domain/Draft';
import { RootUrl } from '@qover/domain';
import { Wizard } from '@qover/hooks/src/useDraft';

type TeslaLayoutProps = {
  chat?: any;
  completionPercentage?: number;
  step?: Path;
  flowStartUrl: string;
  rootUrl: RootUrl;
  wizard: Wizard<Draft>;
};

export function TeslaLayout(props: React.PropsWithChildren<TeslaLayoutProps>) {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const zendeskContext = useContext(ZendeskChatContext);
  const Chatprops = props.chat;
  const { showFaq, showLegalMentions, showFooter } = props.step ?? {};

  return (
    <>
      <GlobalLayoutStyles />
      {zendeskContext.initializeZendesk && (
        <ChatWrapper
          marginBottom="10px"
          marginRight="10px"
          idBedrockElement="footer-container"
        >
          {props.chat ? <Chatprops /> : <Chat loadChat={Config.loadChat} />}
        </ChatWrapper>
      )}
      <TopBar
        completionPercentage={props.completionPercentage}
        flowStartUrl={props.flowStartUrl}
        showChat={showChat}
        showCountrySelectorModal={search.has('id')}
        showLanguageSelector
        updateDraftCountry={props.wizard.updateCountry}
      />
      <InnerContainer>
        {props.children}
        {!!showFaq && <Faq />}
        {!!showLegalMentions && <LegalMentions />}
      </InnerContainer>
      {!!showFooter && (
        <Footer
          showCountrySelectorModal={search.has('id')}
          updateDraftCountry={props.wizard.updateCountry}
          flowStartUrl={props.flowStartUrl}
        />
      )}
    </>
  );
}
